<template>
  <div class="main-container">
      <div class="form-container middle">
          <div class="form">
              <h1 class="form-title">Join Us!</h1>
              <div class="line"></div>
              <div class="row">
                  <input type="text" id="username" v-model="username" />
                  <label for="username" v-bind:class="username != '' ? 'up-position' : null">Username</label>
              </div>
              <div class="row">
                  <input type="password" id="password" v-model="password" />
                  <label for="password" v-bind:class="password != '' ? 'up-position' : null">Password</label>
              </div>
              <div class="row">
                  <input type="password" id="againPassword" v-model="againPassword" />
                  <label for="againPassword" v-bind:class="againPassword != '' ? 'up-position' : null">Again Password</label>
              </div>
              <div class="row">
                  <button @click="register">Register</button>
              </div>
              <div class="line"></div>
              <div class="row">
                  <p class="information">Already have an account? <router-link to="/login">Sign In</router-link></p>
              </div>
              <div class="row error-container" v-if="errors.length != 0">
                  <p class="error-text" v-for="(item, index) in errors" :key="index" >
                    {{ index+1 }}. {{ item }}
                  </p>
                  <i class="fas fa-times close-error" @click="closeError"></i>
              </div>
          </div>
      </div>
      <div class="svg-container">
          <img src="./../assets/register.svg" alt="register-image">
      </div>
  </div>
</template>

<script>
import UserService from './../services/userService';
import Cookies from 'js-cookie';

export default {
    name:'Register',
    data() {
        return {
            username:'',
            password: '',
            againPassword: '',
            errors: []
        }
    },
    async created() {
        const user = Cookies.get('user-id');
        if (user != '') {
            const result = await UserService.getUser({ userId: user });
            if (result.data.username != undefined) {
                this.$router.push('/p/'+result.data.username);
            }
        }
    },
    methods: {
        async register() {
            if (!this.registerValidation()) {
                return;
            }

            let user = {
                username: this.username,
                password: this.password
            };

            const result = await UserService.register(user);
            
            if (result.data.user != undefined) {
                Cookies.set('user-id', result.data.user._id);
                
                setTimeout(() => {
                    this.$router.push('/p/'+result.data.user.username);
                }, 1000);
            }
            this.errors.push(result.data.message);
        },
        registerValidation() {
            this.errors = [];

            if (this.username == '') {
                this.errors.push('Enter an username!');
            }
            if (this.username.length < 3) {
                this.errors.push('Username must longer than 3.');
            }
            if (this.password == '') {
                this.errors.push('Enter a password!');
            }
            if (this.againPassword == '') {
                this.errors.push('Enter an again password!');
            }
            if (this.password.length > 6) {
                if (this.password != this.againPassword) {
                    this.errors.push('Passwords are doesn\'t match.');
                }
            }
            else {
                this.errors.push('Password must longer than 6.');
            }

            return this.errors.length == 0 ? true : false;
        },
        closeError() {
            this.errors = [];
        }
    }
}
</script>

<style scoped>

@import url('./../css/form.css');

.main-container {
    width: 100%;
    height: 100vh;
    position: relative;
}

.svg-container {
    position: absolute;
    right: 0px;
    top: 0px;
    height: 100vh;
    width: 50%;
}

.svg-container img {
    height: 100%;
    width: 100%;
}

</style>